"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = exports.reset = void 0;
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const App_vue_1 = tslib_1.__importDefault(require("./App.vue"));
const router_1 = tslib_1.__importDefault(require("./router"));
const store_1 = tslib_1.__importDefault(require("./store"));
const MachineSecretManager_1 = tslib_1.__importDefault(require("./lib/MachineSecretManager"));
const challenges_1 = tslib_1.__importDefault(require("./components/challenges"));
const ChallengeType_1 = require("./enums/ChallengeType");
const setup_1 = tslib_1.__importDefault(require("../tests/e2e/setup"));
const ChallengeStatus_1 = require("./enums/ChallengeStatus");
let mockPromise = null;
if (process.env.ALBUS_LOCAL_DEV === 'cypress') {
    mockPromise = (0, setup_1.default)();
}
if (process.env.NODE_ENV === 'development') {
    vue_1.default.config.devtools = true;
}
// ignore FDIC web component
vue_1.default.config.ignoredElements = ['iris-fdic-notice'];
let vm;
let config;
function reset() {
    if (vm) {
        vm.$destroy();
    }
}
exports.reset = reset;
function init(providedConfig) {
    if (vm) {
        reset();
    }
    config = providedConfig;
    // Let's do some validation checks
    if (!config.clientKey) {
        throw new Error('You must specify a clientKey as a Guid');
    }
    if (!config.redirectUrl) {
        throw new Error('A redirectUrl was not specified.');
    }
    if (!config.sessionId) {
        throw new Error('A sessionId was not specified.');
    }
    if (!config.elementId || !document.getElementById(config.elementId)) {
        throw new Error('A valid elementId must be provided');
    }
    const componentOverrides = {};
    const challengeTypes = Object.keys(ChallengeType_1.ChallengeType);
    // Sanitize list so extra components don't get added.
    // We don't want someone inserting components in the global scope willy nilly.
    const configuredComponentOverrides = config.componentOverrides || {};
    if (configuredComponentOverrides) {
        const keys = Object.keys(configuredComponentOverrides);
        keys.forEach((key) => {
            if (challengeTypes.includes(key)) {
                componentOverrides[key] = configuredComponentOverrides[key];
            }
        });
    }
    // make sure we do not have a ellipsis config with info href as we are replacing it
    if (config.ellipsisConfig) {
        const index = config.ellipsisConfig.findIndex((obj) => obj.href === '/Mobile/Info');
        if (index >= 0) {
            config.ellipsisConfig.splice(index, 1);
        }
    }
    const globalComponents = { ...challenges_1.default, ...componentOverrides };
    Object.entries(globalComponents).forEach((entry) => {
        vue_1.default.component(entry[0], entry[1]);
    });
    vm = new vue_1.default({
        router: (0, router_1.default)(config),
        store: store_1.default,
        created() {
            MachineSecretManager_1.default.createProvider(config.machineSecretProvider);
            this.$store.commit('configuration', config);
            if (sessionStorage.getItem(ChallengeStatus_1.ChallengeStatus.SessionExpired) === 'true') {
                this.$store.commit('challengeStatus', ChallengeStatus_1.ChallengeStatus.SessionExpired);
                sessionStorage.removeItem(ChallengeStatus_1.ChallengeStatus.SessionExpired);
            }
            if (process.env.ALBUS_LOCAL_DEV === 'cypress') {
                this.$store.commit('isCypress', true);
            }
        },
        render: (h) => h(App_vue_1.default), // This will render the App.vue component imported above
    }).$mount('#' + config.elementId); // This will search for an element in the DOM with an ID of "app"
}
exports.init = init;
const global = window;
global.Alkami = global.Alkami || {};
global.Alkami.Isotope = {
    init,
};
if (mockPromise) {
    void mockPromise.then(() => fetch('/Isotope/Configuration')
        .then(response => response.json())
        .then((data) => {
        var _a;
        // add some CSS classes that get lost in Cypress
        if ((_a = data.baseUrl) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes('mobile')) {
            document.body.classList.add('isotope-mobile');
        }
        switch (data.initialChallengeType) {
            case 'UsernameAndPassword':
                document.body.classList.add('Authentication');
                break;
            case 'StartForgotPassword':
                document.body.classList.add('ForgotPassword');
                break;
            case 'StartForgotUsername':
                document.body.classList.add('ForgotUsername');
                break;
        }
        init(data);
    }));
}
